import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";

const Resume = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulating a delay for demonstration purposes
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="resume">
      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "800px" }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <embed
          src="https://rxresu.me/itchiraira/isaiah-chiraira"
          width="100%"
          height="800"
        />
      )}
    </div>
  );
};

export default Resume;
